import { createContext, useContext } from 'react';

const initialValues = {
  googleAnalyticsId: process.env.GA_ANALYTICS_ID || '',
  googleTagManagerId: process.env.GA_TAG_MANAGER_ID || '',
  metaTags: [],
  openGraphMetaTags: {},
  openGraphTwitter: {},
  canonicalUrl: '',
  jsonLdSchema: {},
  pageTitle: '',
};
const initialPageValues = {
  metaTags: [],
  openGraphMetaTags: {},
  openGraphTwitter: {},
  canonicalUrl: '',
  jsonLdSchema: {},
  pageTitle: '',
};

export const SEOGlobalContext = createContext(initialValues);
export const useSEOGlobalContext = () => useContext(SEOGlobalContext);
export const SEOPageContext = createContext(initialPageValues);
export const useSEOPageContext = () => useContext(SEOPageContext);
